import {
	type OrderSetupListResponseDto,
	OrderSetupStatusEnum,
} from "Infrastructure/Api/Api";
import { SettingsPaths } from "Settings/Routes/Routing";
import CloudDone from "@mui/icons-material/CloudDone";
import Drafts from "@mui/icons-material/Drafts";
import TaskAlt from "@mui/icons-material/TaskAlt";
import { ListItemButton, Stack, Typography } from "@mui/material";
// Replace shared status icons with Material equivalents
import { type FC, useMemo } from "react";
import { useNavigate } from "react-router";

type Props = {
	orderSetup: OrderSetupListResponseDto;
	selected?: boolean;
	disabled?: boolean;
};

type OrderSetupStatusIcons = Record<OrderSetupStatusEnum, FC>;

const orderSetupStatusIcons: OrderSetupStatusIcons = {
	deployed: CloudDone,
	ready: TaskAlt,
	draft: Drafts,
};

export const OrderSetupListRow: FC<Props> = ({
	orderSetup,
	selected,
	disabled,
}) => {
	const navigate = useNavigate();

	const handleNavigate = (orderSetupId: number) => {
		navigate(
			SettingsPaths.OrderSetupEdit.path(
				orderSetup.marketId,
				orderSetup.verticalId,
				orderSetupId,
			),
		);
	};

	const IconComponent = useMemo(
		() => orderSetupStatusIcons[orderSetup.status],
		[orderSetup.status],
	);

	return (
		<>
			<ListItemButton
				onClick={() => handleNavigate(orderSetup.id)}
				disabled={disabled}
				selected={selected}
			>
				<Stack direction="row" alignItems="center" gap={2} py={0.5}>
					<Stack
						alignItems="center"
						sx={(theme) => ({
							color:
								orderSetup.status === OrderSetupStatusEnum.deployed
									? theme.palette.success.main
									: "inherit",
						})}
					>
						{IconComponent && <IconComponent />}
					</Stack>
					<Typography variant="body1">{orderSetup.name}</Typography>
				</Stack>
			</ListItemButton>
		</>
	);
};
